import React, { Fragment } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";
// import { faEdit, faTrash, faEuroSign } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// const styles = StyleSheet.create({
   
//     // titleContainer:{
//     //     flexDirection: 'row',
//     //     // marginBottom: 5,
//     //     // marginTop: 5,
//     //     // borderBottomColor: '#bff0fd',
//     //     // borderBottomWidth: 1,
//     // },
//     // reportTitle:{
//     //     fontSize: 10,
//     //     textAlign: 'left',
//     //     color: '#000',
//     //     marginTop: 18,

//     // }
//   });
const styles = StyleSheet.create({

   titleContainer:{
    flexDirection: 'row',
    marginBottom: 2,
    marginTop: 2,
     // borderBottomColor: '#000',
     // borderBottomWidth: 1,
 },
  tableLeft: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
   // borderWidth: 1, 
    //borderRightWidth: 0, 
    //borderBottomWidth: 1, 
     marginBottom: 5,
    //  marginTop: 20,
     marginRight: 5,
     width: "65%",
  }, 
  tableRowLeft: { 
    margin: "auto", 
    flexDirection: "row", 
  }, 
  tableColLeft: { 
    width: "50%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0,
    //textAlign:"left",
    textAlign:'left'
  }, 
  tableColLeftLeft: { 
    width: "50%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0,
    //textAlign:"left",
    borderBottomColor: '#000',
    backgroundColor: '#F5F5F5',
   // textAlign:'left'
  },
  tableCellLeft: { 
    //margin: "auto", 
    marginTop: 5, 
    fontSize: 8,
    textAlign:"left",
    marginLeft:2,
    paddingBottom: 5
  },

  tableRight: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    textAlign:"left",
   // borderBottomWidth: 1, 
     marginBottom: 2,
    //  marginTop: 20,
     marginLeft: 5,
    //marginRight: 5,
     width: "35%",
  }, 
  tableRowRight: { 
    margin: "auto", 
    flexDirection: "row" 
  }, 
  tableColRight: { 
    width: "50%", 
    borderStyle: "solid", 
    borderLeftWidth: 1, 
    borderRightWidth: 0, 
    borderBottom:1,
    borderTopWidth: 0,
    textAlign:"left",
  }, 
  tableColRightLeft: { 
    width: "50%", 
    borderStyle: "solid", 
   // borderWidth: 1, 
    borderLeftWidth: 1, 
    borderBottom:1,
   // borderTopWidth: 0,
    textAlign:"left",
    borderBottomColor: '#000',
    //backgroundColor: '#F5F5F5',
  },
  tableCellRight: { 
   // margin: "auto", 
   marginLeft:2,
    marginTop: 5, 
   // marginBottom: 2, 
    fontSize: 8,
    textAlign:"center",
    paddingBottom: 5
  }
  
});

 
const TotalVoucher = ({invoice}) =>{
  var invoice1 = (JSON.stringify(invoice));
  var invoice2 = JSON.parse(invoice1);
  var invoice3 = JSON.parse(invoice2);

  var clientdetaild = invoice3.child[0];
  if(invoice3?.markupdata?.priceOption =='priceOption1'){
 
    return(
      <Fragment>
          {/* <View style={styles.titleContainer}>
          <Text  style={styles.reportTitle}>{invoice3.agentdetails.first_name+ ' '+invoice3.agentdetails.last_name}</Text>
          </View> */}
          <View style={styles.titleContainer}>
          <View style={styles.tableLeft}> 
         
         </View> 

     <View style={styles.tableRight}> 
         
       
       <View style={styles.tableRowRight}> 
         <View style={styles.tableColRightLeft}> 
           <Text style={styles.tableCellLeft}>Total</Text> 
         </View> 
         <View style={styles.tableColRight}> 
           <Text style={styles.tableCellRight}><b>&#8364; {invoice3.total_main_amount.toFixed(2)}</b> </Text> 
         </View> 
       </View>
       <View style={styles.tableRowRight}> 
         <View style={styles.tableColRightLeft}> 
           <Text style={styles.tableCellLeft}>Discount</Text> 
         </View> 
         <View style={styles.tableColRight}> 
           <Text style={styles.tableCellRight}><b>&#8364; {invoice3.offer_discount.toFixed(2)}</b> </Text> 
         </View> 
       </View>
       <View style={styles.tableRowRight}> 
         <View style={styles.tableColRightLeft}> 
           <Text style={styles.tableCellLeft}>Grand Total</Text> 
         </View> 
         <View style={styles.tableColRight}> 
           <Text style={styles.tableCellRight}><b>&#8364; {invoice3.booking_amount.toFixed(2)}</b> </Text> 
         </View> 
       </View>
      
       
     </View>
     </View>
   </Fragment>
     );
  }else{
    let CommissionPriceTotal = (parseFloat(invoice3?.markupdata?.markupPrice) / 100) * invoice3?.total_main_amount;
    let FinalPriceTotal = parseFloat(invoice3?.total_main_amount + CommissionPriceTotal);

    let CommissionPriceBooking = (parseFloat(invoice3?.markupdata?.markupPrice) / 100) * invoice3.booking_amount;
    let FinalPriceBooking = parseFloat(invoice3.booking_amount + CommissionPriceBooking);
    let discountPrice = FinalPriceTotal-FinalPriceBooking
    return(
       <Fragment>
           {/* <View style={styles.titleContainer}>
           <Text  style={styles.reportTitle}>{invoice3.agentdetails.first_name+ ' '+invoice3.agentdetails.last_name}</Text>
           </View> */}
           <View style={styles.titleContainer}>
           <View style={styles.tableLeft}> 
          
          </View> 

      <View style={styles.tableRight}> 
          
        
        <View style={styles.tableRowRight}> 
          <View style={styles.tableColRightLeft}> 
            <Text style={styles.tableCellRight}>Total</Text> 
          </View> 
          <View style={styles.tableColRight}> 
            <Text style={styles.tableCellRight}><b>&#8364; {FinalPriceTotal.toFixed(2)}</b> </Text> 
          </View> 
        </View>
        <View style={styles.tableRowRight}> 
          <View style={styles.tableColRightLeft}> 
            <Text style={styles.tableCellRight}>Discount</Text> 
          </View> 
          <View style={styles.tableColRight}> 
            <Text style={styles.tableCellRight}><b>&#8364; {discountPrice.toFixed(2)}</b> </Text> 
          </View> 
        </View>
        <View style={styles.tableRowRight}> 
          <View style={styles.tableColRightLeft}> 
            <Text style={styles.tableCellRight}>Grand Total</Text> 
          </View> 
          <View style={styles.tableColRight}> 
            <Text style={styles.tableCellRight}><b>&#8364; {FinalPriceBooking.toFixed(2)}</b> </Text> 
          </View> 
        </View>
       
        
      </View>
      </View>
    </Fragment>
      );
  }
 } 
  
  export default TotalVoucher